export default "__VITE_ASSET__64b1ed01__"